import React from 'react'
import { routerType } from '../../PublicNavigation'
import { KaryonModules } from '../../../../../../redux/user/userTypes'
import { PagesName } from '../../../types/pages'
import { PDMDashboard } from '../../../../../../pages/private/Retail/Market-share/PDMDashboard'
import { PDMPointOfSale } from '../../../../../../pages/private/Retail/Market-share/PDMPointOfSale'
import { PDMSuppliers } from '../../../../../../pages/private/Retail/Market-share/PDMSuppliers'
import { PDMProducts } from '../../../../../../pages/private/Retail/Market-share/PDMProducts'


export const MarketShareRouter = (modules: KaryonModules[]): routerType[] => [
    {
        path: 'dashboard/',
        element: <PDMDashboard />,
        title: PagesName.DASHBOARD,
    },
    {
        path: 'pointsdevente/',
        element: <PDMPointOfSale />,
        title: PagesName.WAREHOUSES,
    },
    {
        path: 'fournisseurs/',
        element: <PDMSuppliers />,
        title: PagesName.SUPPLIERS,
    },
    {
        path: 'produits/',
        element: <PDMProducts />,
        title: PagesName.PRODUCTS,
    },
]
